import { BASE_API_URL } from '@env';
import { useMutation } from 'react-query';

interface ForgotPasswordRequest {
  email: string;
}

interface ForgotPasswordResponse {
  message: string;
}

export function useForgotPassword() {
  const mutation = useMutation<ForgotPasswordResponse, Error, ForgotPasswordRequest>(
    async (data: ForgotPasswordRequest) => {
      const response = await fetch(`${BASE_API_URL}users/auth/forgot-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'accept': 'application/json',
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.detail || 'Failed to send password reset email');
      }

      return response.json();
    }
  );

  return mutation;
}
